const DEFAULT_PUBLIC_PATH = 'https://web.51zidan.com/__modules'

export function getFfmpegCorePath () {
  return (process.env.VUE_APP_PUBLIC_PATH || DEFAULT_PUBLIC_PATH) + '/ffmpeg/ffmpeg-core.js'
}

export function getMapGeoFound() {
    return (process.env.VUE_APP_PUBLIC_PATH || DEFAULT_PUBLIC_PATH) + '/map-geojson'
}
